module.exports = __webpack_public_path__ + "img/signo_precio.81bb95f0.svg";